<template>
    <div v-show="visible">
        <el-dialog title="修改商品详情" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible" :before-close="dialogClose" width="800px">    
            <div>
                <mavon-editor
                    :toolbars="markdownOption" 
                    v-model="form.content" 
                    :ishljs = "true"
                    @change="changeData"/>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {mavonEditor} from 'mavon-editor';
    import 'mavon-editor/dist/css/index.css';
    import { Base64 } from 'js-base64';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    id:"",
                    content:"",
                    htmlContent:"",
                },
                markdownOption: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: false, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    /* 1.3.5 */
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: false, // 保存（触发events中的save事件）
                    /* 1.4.2 */
                    navigation: true, // 导航目录
                    /* 2.1.8 */
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    /* 2.2.1 */
                    subfield: true, // 单双栏模式
                    preview: true, // 预览
                }
            }
        },
        components: {
            mavonEditor
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible = true
                this.form.id = data.id
                this.form.content = (data.content==null?'':data.content)
                this.form.htmlContent = (data.htmlContent == null?'':data.htmlContent)
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                
                let markdownIt = mavonEditor.markdownIt
               
                this.loading=true;
                let url= this.commodityUpdateContentUrl;
                let data = {
                    id:this.form.id,
                    content:(this.form.content==''?'':Base64.encode(this.form.content)),
                    htmlContent:(this.form.htmlContent==''?'':Base64.encode(this.form.htmlContent))
                };
                
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.visible=false;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            changeData(value, render) {
                // console.log("值："+value);
                // console.log("渲染："+render);
                this.form.htmlContent=render;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/shop/wares/UpdateContent.vue